import request from '@/plugins/axios'

/**
 * 构造带管理员身份的请求配置
 *
 * @param {Object} config 请求配置
 * @returns {Object} 附带 Authorization 头的请求配置
 */
function adminRequest(config) {
	const token = window.localStorage.getItem('adminToken')
	return {
		...config,
		headers: {
			Authorization: token
		}
	}
}

/**
 * 获取书签页面数据（分类 + 书签）
 *
 * @returns {Promise} 响应对象，data 为 {categories, bookmarks}
 */
export function getBookmarks() {
	return request({
		url: 'bookmarks',
		method: 'GET'
	})
}

/**
 * 书签点击次数加一
 *
 * @param {Number} id 书签 ID
 * @returns {Promise} 响应对象
 */
export function clickBookmark(id) {
	return request({
		url: 'bookmark/click',
		method: 'POST',
		params: {id}
	})
}

/**
 * 新增书签
 *
 * @param {Object} bookmark 书签数据
 * @returns {Promise} 响应对象
 */
export function saveBookmark(bookmark) {
	return request(adminRequest({
		url: 'bookmark',
		method: 'POST',
		data: bookmark
	}))
}

/**
 * 修改书签
 *
 * @param {Object} bookmark 书签数据，必须包含 id
 * @returns {Promise} 响应对象
 */
export function updateBookmark(bookmark) {
	return request(adminRequest({
		url: 'bookmark',
		method: 'PUT',
		data: bookmark
	}))
}

/**
 * 删除书签
 *
 * @param {Number} id 书签 ID
 * @returns {Promise} 响应对象
 */
export function deleteBookmark(id) {
	return request(adminRequest({
		url: 'bookmark',
		method: 'DELETE',
		params: {id}
	}))
}

/**
 * 新增书签分类
 *
 * @param {Object} category 分类数据
 * @returns {Promise} 响应对象
 */
export function saveBookmarkCategory(category) {
	return request(adminRequest({
		url: 'bookmarkCategory',
		method: 'POST',
		data: category
	}))
}

/**
 * 修改书签分类
 *
 * @param {Object} category 分类数据，必须包含 id
 * @returns {Promise} 响应对象
 */
export function updateBookmarkCategory(category) {
	return request(adminRequest({
		url: 'bookmarkCategory',
		method: 'PUT',
		data: category
	}))
}

/**
 * 删除书签分类
 *
 * @param {Number} id 分类 ID
 * @returns {Promise} 响应对象
 */
export function deleteBookmarkCategory(id) {
	return request(adminRequest({
		url: 'bookmarkCategory',
		method: 'DELETE',
		params: {id}
	}))
}

/**
 * 批量重排书签
 *
 * @param {Array<Number>} ids 按目标顺序排列的书签 ID
 * @returns {Promise} 响应对象
 */
export function sortBookmarks(ids) {
	return request(adminRequest({
		url: 'bookmarks/sort',
		method: 'PUT',
		data: ids
	}))
}

/**
 * 修改书签分类的仪表盘尺寸
 *
 * @param {Number} id 分类 ID
 * @param {String} size 尺寸标识：small/wide/tall/large
 * @returns {Promise} 响应对象
 */
export function updateBookmarkCategorySize(id, size) {
	return request(adminRequest({
		url: 'bookmarkCategory/size',
		method: 'PUT',
		params: {id, size}
	}))
}

/**
 * 批量重排书签分类
 *
 * @param {Array<Number>} ids 按目标顺序排列的分类 ID
 * @returns {Promise} 响应对象
 */
export function sortBookmarkCategories(ids) {
	return request(adminRequest({
		url: 'bookmarkCategories/sort',
		method: 'PUT',
		data: ids
	}))
}

/**
 * 导出书签 JSON 备份数据
 *
 * @returns {Promise} 响应对象，data 为导出结构
 */
export function exportBookmarks() {
	return request(adminRequest({
		url: 'bookmarks/export',
		method: 'GET'
	}))
}

/**
 * 抓取网页标题与图标
 *
 * @param {String} url 目标网页地址
 * @returns {Promise} 响应对象，data 为 {title, icon}
 */
export function fetchBookmarkMeta(url) {
	return request(adminRequest({
		url: 'bookmark/meta',
		method: 'GET',
		params: {url}
	}))
}
